import FeatureCard from "./FeatureCard";
import bluetooth from "../../assets/icons/bluetooth.svg";
import dinning from "../../assets/icons/dinning.svg";
import pilot from "../../assets/icons/pilot.svg";
import music from "../../assets/icons/music.svg";
import liveJacket from "../../assets/icons/life-jacket.svg";
import fire from "../../assets/icons/fire.svg";
import boot from "../../assets/icons/boot.svg";
import firstAid from "../../assets/icons/firstAid.svg";
import anchor from "../../assets/icons/anchor.svg";
import radio from "../../assets/icons/radio.svg";
import biscuit from "../../assets/icons/special-buscuit.svg";
import googles from "../../assets/icons/googles.svg";
import distress from "../../assets/icons/distress.svg";
import { Typography } from "@material-tailwind/react";
import { Fragment, useState } from "react";
import NextBack from "./NextBack";
import { useOnboardingStore } from "../../store/onboarding/Onboarding";
import { useMutation } from "react-query";
import api from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import { BoatService, createBoat } from "../../services/boatService";
import { useBoatDetailsStore } from "../../store/boat/boatDetails";
import { useAddressStore } from "../../store/boat/address";
import AuthService from "../../services/authService";
import { toast } from "react-toastify";
import { handleErrorMessage } from "../../utility";

function AddFeatures() {
  const [pilotActive, setPilotActive] = useState(false);
  const [lifeJacketActive, setLifeJacketActive] = useState(false);
  const [bluetoothActive, setBluetoothActive] = useState(false);
  const [diningActive, setDiningActive] = useState(false);
  const [musicActive, setMusicActive] = useState(false);
  const [fireActive, setFireActive] = useState(false);
  const [bootActive, setBootActive] = useState(false);
  const [firstAidActive, setFirstAidActive] = useState(false);
  const [anchorActive, setAnchorActive] = useState(false);
  const [radioActive, setRadioActive] = useState(false);
  const [biscuitActive, setBiscuitActive] = useState(false);
  const [googlesActive, setGooglesActive] = useState(false);
  const [distressActive, setDistressActive] = useState(false);
  const { setStepNumber, setOnBoardingPage, setTab } = useOnboardingStore();
  const { boat } = useBoatDetailsStore();
  const { address } = useAddressStore();

  const features = [
    {
      icon: pilot,
      title: "Pilot",
      active: pilotActive,
      onClick: () => {
        setPilotActive(!pilotActive);
      },
    },
    {
      icon: liveJacket,
      title: "Live Jacket",
      active: lifeJacketActive,
      onClick: () => {
        setLifeJacketActive(!lifeJacketActive);
      },
    },
    {
      icon: bluetooth,
      title: "Bluetooth",
      active: bluetoothActive,
      onClick: () => {
        setBluetoothActive(!bluetoothActive);
      },
    },
    {
      icon: dinning,
      title: "Dining",
      active: diningActive,
      onClick: () => {
        setDiningActive(!diningActive);
      },
    },
    {
      icon: music,
      title: "Music",
      active: musicActive,
      onClick: () => {
        setMusicActive(!musicActive);
      },
    },
    {
      icon: fire,
      title: "Fire Extinguisher",
      active: fireActive,
      onClick: () => {
        setFireActive((prev) => !prev);
      },
    },
    {
      icon: boot,
      title: "Safety boot",
      active: bootActive,
      onClick: () => {
        setBootActive((prev) => !prev);
      },
    },
    {
      icon: firstAid,
      title: "First Aid Kit",
      active: firstAidActive,
      onClick: () => {
        setFirstAidActive((prev) => !prev);
      },
    },
    {
      icon: anchor,
      title: "Anchor",
      active: anchorActive,
      onClick: () => {
        setAnchorActive((prev) => !prev);
      },
    },
    {
      icon: radio,
      title: "VHF Radio",
      active: radioActive,
      onClick: () => {
        setRadioActive((prev) => !prev);
      },
    },
    {
      icon: biscuit,
      title: "Special Biscuit",
      active: biscuitActive,
      onClick: () => {
        setBiscuitActive((prev) => !prev);
      },
    },
    {
      icon: googles,
      title: "Googles",
      active: googlesActive,
      onClick: () => {
        setGooglesActive((prev) => !prev);
      },
    },
    {
      icon: distress,
      title: "Distress Signal",
      active: distressActive,
      onClick: () => {
        setDistressActive((prev) => !prev);
      },
    
    }
  ];

  const createBoatMutation = useMutation(
    (data: createBoat) => api.post(ApiRoutes.createBoat, data),
    {
      onSuccess(data, variables) {
        console.log(data);
        console.log(variables);
        BoatService.saveCurrentBoatId(data.data.payload.data.result.id);
        toast.success("Boat created successfully");
        setStepNumber(4);
        setOnBoardingPage("Photos");
        setTab("Photos");
      },
      onError: (error) => {
        handleErrorMessage(
          error,
          "Unable to create boat. Please try again later."
        );
      },
    }
  );

  return (
    <Fragment>
      <div className="lg:mx-[10%]">
        <Typography
          placeholder={undefined}
          className="font-normal text-2xl mb-4 text-center"
        >
          Key Features
        </Typography>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 justify-start my-9">
          {features.slice(0, 2).map((feature, index) => (
            <FeatureCard
              key={index}
              active={feature.active}
              icon={feature.icon}
              title={feature.title}
              onClick={feature.onClick}
            />
          ))}
        </div>

        <Typography
          placeholder={undefined}
          className="font-normal text-2xl mt-10 text-center m-5"
        >
          Additional Services
        </Typography>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 justify-start my-9">
          {features.slice(2).map((feature, index) => (
            <FeatureCard
              key={index}
              active={feature.active}
              icon={feature.icon}
              title={feature.title}
              onClick={feature.onClick}
            />
          ))}
        </div>
      </div>
      <NextBack
        isLoading={createBoatMutation.isLoading}
        shouldGoNext={true}
        next={() => {
          const feat = features
            .filter((feature) => feature.active)
            .map((feature) => feature.title);
          console.log(feat);
          const year = new Date(boat.boatYear!).getUTCFullYear();

          const newBoat = {
            ...boat,
            year: year.toString(),
            country: "Nigeria",
            features: feat,
            lastMaintenanceDate: boat.lastMaintenance!,
            ...address,
            userId: AuthService.user!.data.id,
          };
          console.log(newBoat);

          createBoatMutation.mutate(newBoat);
        }}
        back={() => {
          setStepNumber(2);
          setOnBoardingPage("Address");
          setTab("Address");
        }}
      />
    </Fragment>
  );
}

export default AddFeatures;
